export default __webpack_public_path__ + "static/media/98-12_header_invoice.a9c27d00.png";